<template>
  <div class="donut-legend-list">
    <div v-if="title" class="donut-legend-title">{{ title }}</div>
    <div v-for="(item, index) in items" :key="item.label" class="donut-legend-row">
      <span class="donut-legend-swatch" :style="{ background: colors[index % colors.length] }"></span>
      <span class="donut-legend-label">{{ item.label }}</span>
      <span class="donut-legend-value">{{ item.value }}<template v-if="item.share !== undefined"> ({{ formatShare(item.share) }})</template></span>
    </div>
  </div>
</template>

<script>
import { formatNum } from '@/util/number';

export default {
  name: 'DonutLegend',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    colors: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
  },
  methods: {
    formatShare(share) {
      return `${formatNum(share, 1)}%`;
    },
  },
};
</script>

<style scoped>
.donut-legend-list {
  font-size: var(--mz-fs-base);
  line-height: 1.6;
  flex: 1;
  min-width: 0;
}

.donut-legend-title {
  font-size: var(--mz-fs-sm);
  color: var(--mz-text-muted);
}

/* value boleh turun ke bawah label */
.donut-legend-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0 6px;
}

.donut-legend-value {
  overflow-wrap: anywhere;
}

.donut-legend-swatch {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  flex: none;
}

.donut-legend-label {
  font-weight: 600;
}
</style>
